export default __webpack_public_path__ + "static/media/49_desktop.b1aa2ddc.jpg";